import { Button, Center, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useFreezeDate } from '@/feature/utils/hooks/useFreezeDate';

export function BibtexResearcherSync() {
  const { t } = useTranslation();
  const { isAfterFreezeDate } = useFreezeDate();

  return (
    <Paper
      component="section"
      aria-label={t('dashboard.cards.bibtex')}
      flex={1}
      p="md"
      mih="200px"
    >
      <Stack gap="4px">
        <Text>BibTeX / Google Scholar</Text>
        <Text
          c="dimmed"
          size="sm"
          fs="italic"
        >
          {t('sync.bibtex.meta')}
        </Text>
        <Center mt="20px">
          <Button
            component={Link}
            to="/sync-bibtex"
            disabled={isAfterFreezeDate}
          >
            {t('button.import')}
          </Button>
        </Center>
      </Stack>
    </Paper>
  );
}
